import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-star-inactive",
  "use": "svg-icon-star-inactive-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"svg-icon-star-inactive\"><path d=\"M18.779 7.354l-5.907-.859-.233-.471-2.408-4.88a.257.257 0 00-.462 0L7.13 6.495l-.52.076-5.388.783a.257.257 0 00-.142.439l4.274 4.166-.089.518-.92 5.365c-.036.21.184.37.373.27L10 15.335l.465.244 4.818 2.533c.189.1.41-.061.374-.27l-1.01-5.883.376-.367 3.898-3.8a.257.257 0 00-.142-.438z\" fill-rule=\"nonzero\" stroke=\"#BAC6CC\" stroke-width=\"2\" fill=\"none\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol